/** Optimistic patches to query caches without changing UI behavior. */

function patchEventGoingCount(rows, eventId, delta) {
  if (!rows || delta === 0) return rows;
  return rows.map((e) => {
    if (e.event_id !== eventId) return e;
    const gc = typeof e.going_count === 'number' ? e.going_count : Number(e.going_count) || 0;
    const nextGc = Math.max(0, gc + delta);
    return { ...e, going_count: nextGc, event_rsvps: [{ count: nextGc }] };
  });
}

export function patchGoingCountInInfiniteFeed(queryClient, feedKey, eventId, delta) {
  if (!delta) return;
  queryClient.setQueryData(feedKey, (old) => {
    if (!old?.pages) return old;
    return {
      ...old,
      pages: old.pages.map((page) => patchEventGoingCount(page, eventId, delta)),
    };
  });
}

export function patchGoingCountInEventList(queryClient, listKey, eventId, delta) {
  if (!delta) return;
  queryClient.setQueryData(listKey, (old) => patchEventGoingCount(old, eventId, delta));
}

export function computeRsvpGoingDelta(oldStatus, newStatus) {
  if (oldStatus === 'going' && newStatus !== 'going') return -1;
  if (oldStatus !== 'going' && newStatus === 'going') return 1;
  return 0;
}
